/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const WarningFilledIcon = /*#__PURE__*/ createSvgIcon(
  'WarningFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2.331 17a.735.735 0 01-.665-.375.631.631 0 01-.093-.375.898.898 0 01.114-.396L9.354 3.063a.621.621 0 01.282-.271.849.849 0 01.728 0 .622.622 0 01.282.27l7.666 12.792c.07.125.108.257.115.396a.631.631 0 01-.094.375.84.84 0 01-.27.271.728.728 0 01-.395.104H2.331zm7.664-2.5c.212 0 .39-.071.536-.214a.714.714 0 00.219-.531.736.736 0 00-.215-.536.714.714 0 00-.53-.219.736.736 0 00-.536.214.714.714 0 00-.22.532c0 .211.072.39.215.535.143.146.32.22.531.22zm0-2.5c.212 0 .39-.072.536-.216a.72.72 0 00.219-.534v-2.5a.728.728 0 00-.215-.534.72.72 0 00-.53-.216.734.734 0 00-.536.216.72.72 0 00-.22.534v2.5c0 .213.072.39.215.534a.72.72 0 00.531.216z"
            fill="#A32E00"
          />
        </>
      ),
    },
  },
  false
);

export default WarningFilledIcon;
